import { graphql } from '../gql';

export const getVendorMenuTemplates = graphql(`
  query GetVendorMenuTemplates($vendorId: ID!) {
    getVendorMenuTemplates(input: { vendorId: $vendorId }) {
      error {
        code
        message
      }
      menuTemplates {
        id
        name
        productType
        state
        mealPeriods
        recentlyUpdated
        startDate
        endDate
        updatedAt
      }
    }
  }
`);
